import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class MensajeriaValidacionFormRegistroService {

  private validationMessagerForm: any;
  constructor(private http: HttpClient) {}

  validationMessages(){
    return this.http.get("../mensajes-validacion.json");
  }

  getValidationMessages(field: string, erroKey: string) {
    return this.validationMessagerForm[field]?.[erroKey] || '';

  }

  setValidationMessages(message: any){
    this.validationMessagerForm = message
  }
}
